import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { EMPLOYEE_API } from "../apiRoutes";

interface UseGetEmployeeByIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getEmployeeById = async (id: string) =>
  await axiosAuth.get(`${EMPLOYEE_API}/${id}`);

const useGetEmployeeById = ({
  id,
  queryParams,
}: UseGetEmployeeByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["employee", id],
    queryFn: () => getEmployeeById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!id && (queryParams?.enabled ?? true),
  });
};

export default useGetEmployeeById;
